// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eeba93f0","455":"da4c6009","977":"7b963530"}[chunkId] + ".chunk.js";
};